import { AbstractScheduler } from './abstract.scheduler';
export class IdleTaskScheduler extends AbstractScheduler {
  constructor(...args) {
    super(...args);
    this.callbackTimestampMap = new Map();
  }
  static isSupported() {
    return 'requestIdleCallback' in window;
  }
  schedule(callback) {
    if (!IdleTaskScheduler.isSupported()) {
      throw new Error('requestIdleCallback is not supported');
    }
    if (!this.callbackTimestampMap.has(callback)) {
      this.callbackTimestampMap.set(callback, performance.now());
    } else {
      const timestamp = this.callbackTimestampMap.get(callback);
      if (performance.now() - timestamp > IdleTaskScheduler.IDLE_TASK_DEADLINE) {
        callback();
        return () => {};
      }
    }
    const idleCallbackId = window.requestIdleCallback(deadline => {
      if (deadline.timeRemaining() <= IdleTaskScheduler.IDLE_TASK_THRESHOLD && !deadline.didTimeout) {
        this.schedule(callback);
        return;
      }
      callback();
    }, {
      timeout: IdleTaskScheduler.IDLE_TASK_TIMEOUT
    });
    return () => window.cancelIdleCallback(idleCallbackId);
  }
}
IdleTaskScheduler.IDLE_TASK_TIMEOUT = 2000;
IdleTaskScheduler.IDLE_TASK_THRESHOLD = 25;
IdleTaskScheduler.IDLE_TASK_DEADLINE = 10000;